import { useTranslation } from 'react-i18next';
import { Textfield } from '@digdir/designsystemet-react';

import { useOmBoligenFormContext } from '../utils';
import { useOmBoligenValidation } from '../hooks/useOmBoligenValidation';
import { parseNorwegianFormattedNumber } from '../../../../../../utils/utils';

export const TotalOppvarmetBraBygningInput = () => {
  const { t } = useTranslation();
  const { register, formState } = useOmBoligenFormContext();
  const { validateOppvarmetBruksarealForHeleBygningen } = useOmBoligenValidation();

  const error = formState.errors.bygginfo?.totalOppvarmetBraBygning?.message;

  return (
    <Textfield
      type="text"
      inputMode="decimal"
      label={t('register.bygningsdetaljer.totalOppvarmetBraBygning.label')}
      description={t('register.bygningsdetaljer.totalOppvarmetBraBygning.information')}
      suffix={t('register.solar.form.suffix.sqm')}
      error={error}
      {...register('bygginfo.totalOppvarmetBraBygning', {
        shouldUnregister: true,
        setValueAs: (value) => parseNorwegianFormattedNumber(value),
        validate: validateOppvarmetBruksarealForHeleBygningen
      })}
    />
  );
};
